import { useContext, useState } from 'react';
import { PrimaryButton } from '../atoms';
import type { UserType } from '../../contexts';
import { isPlatformAdmin, isTenantAdmin, UserContext } from '../../contexts';
import { NewUserMerchantModal, NewUserPlatformModal } from '../molecules';
import { Navigate } from 'react-router-dom';
import { Logger } from '../../common';

type TUsersHeader = {
  refreshPage: () => void;
};

const UsersHeader = ({ refreshPage }: TUsersHeader) => {
  const [modalOpen, setModalOpen] = useState(false);

  const { user } = useContext(UserContext);
  const merchantId = user.merchantId;

  const role: UserType = user.userType;

  let buttonText: string;
  switch (role) {
    case 'platformAdmin':
      buttonText = 'Platform User';
      break;
    case 'tenantAdmin':
      buttonText = 'User';
      break;
    default:
      Logger.error({
        source: 'UserHeader',
        message: 'Invalid user role for creating an account'
      });
      return <Navigate to="/dashboard" replace />;
  }

  const handleOpen = () => {
    setModalOpen(true);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  };

  const handleClose = () => {
    setModalOpen(false);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  return (
    <>
      <h1>Users</h1>
      <PrimaryButton onClick={handleOpen}>
        New {buttonText} <span className="material-symbols-rounded">add</span>
      </PrimaryButton>

      {isTenantAdmin(role) && (
        <NewUserMerchantModal
          merchantId={merchantId}
          isModalOpen={modalOpen}
          handleModalClose={handleClose}
          refreshPage={refreshPage}
          hideRole={true} // merchant admin can't create merchant admin users in cognito
        />
      )}

      {isPlatformAdmin(role) && (
        <NewUserPlatformModal
          isModalOpen={modalOpen}
          handleModalClose={handleClose}
          refreshPage={refreshPage}
        />
      )}
    </>
  );
};

export { UsersHeader };
